<template>
	<section class="view-ui-icon-extras">
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M21.5501 0H15.0033C13.9487 0 13.0938 0.854918 13.0938 1.90951V8.45642C13.0938 9.51101 13.9487 10.3659 15.0033 10.3659H21.5501C22.6047 10.3659 23.4596 9.51101 23.4596 8.45642V1.90951C23.4596 0.854918 22.6047 0 21.5501 0Z"
				fill="currentColor"
			/>
			<path
				d="M23.4413 16.9267L19.6266 13.1119C19.2681 12.7547 18.7826 12.5541 18.2765 12.5541C17.7704 12.5541 17.285 12.7547 16.9265 13.1119L13.1117 16.9267C12.7542 17.2851 12.5535 17.7706 12.5535 18.2768C12.5535 18.783 12.7542 19.2685 13.1117 19.6269L16.9265 23.4416C17.2848 23.7992 17.7703 24 18.2765 24C18.7827 24 19.2683 23.7992 19.6266 23.4416L23.4413 19.6269C23.799 19.2686 23.9999 18.7831 23.9999 18.2768C23.9999 17.7705 23.799 17.285 23.4413 16.9267Z"
				fill="currentColor"
			/>
			<path
				d="M8.45636 0H1.90952C0.85494 0 3.05176e-05 0.854918 3.05176e-05 1.90951V8.45642C3.05176e-05 9.51101 0.85494 10.3659 1.90952 10.3659H8.45636C9.51094 10.3659 10.3659 9.51101 10.3659 8.45642V1.90951C10.3659 0.854918 9.51094 0 8.45636 0Z"
				fill="currentColor"
			/>
			<path
				d="M8.45636 13.0938H1.90952C0.85494 13.0938 3.05176e-05 13.9487 3.05176e-05 15.0033V21.5502C3.05176e-05 22.6048 0.85494 23.4597 1.90952 23.4597H8.45636C9.51094 23.4597 10.3659 22.6048 10.3659 21.5502V15.0033C10.3659 13.9487 9.51094 13.0938 8.45636 13.0938Z"
				fill="currentColor"
			/>
		</svg>
	</section>
</template>

<script lang="ts">
	import ChalkySticks from '@chalkysticks/sdk';
	import ViewBase from '@/Core/View.vue';
	import { Component } from 'vue-property-decorator';

	/**
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package View/Ui/Icon
	 * @project ChalkySticks App
	 */
	@Component
	export default class ViewUiIconExtras extends ViewBase {
		// Not implemented
	}
</script>
